import { useState } from "react";
import ENDPOINT from "../context/EndPoint";

export default function StudentExcel() {
  const [url, setUrl] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async () => {
    if (!url) {
      setStatus("Please enter URL");
      return;
    }

    setStatus("Processing...");

    try {
      const res = await fetch( ENDPOINT +"excelserver.jsx", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fileUrl: url })
      });

      if (!res.ok) throw new Error();

      const blob = await res.blob();

      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = "processed.xlsx";
      a.click();

      setStatus("Download started");
    } catch (err) {
      setStatus("Error occurred");
    }
  };

  return (
    <div style={{ padding: "40px" }}>
      <h2>Student Excel Processor</h2>

      <input
        type="text"
        placeholder="Paste Excel URL"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        style={{ width: "400px", padding: "10px" }}
      />

      <br /><br />

      <button onClick={handleSubmit}>
        Process
      </button>

      <p>{status}</p>
    </div>
  );
}